import React, { useEffect } from 'react';
import { Table, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  BUY,
  ExecutionErrorType,
  ORDER_STATUSES,
  PartialOrderType,
  retrieveExecutionErrors,
  retrievePendingMoos,
  retrievePendingSlTps,
  retrieveTriedAndFailedOrders,
  selectors,
  TRANSACTION_TYPES,
  TriedAndFailedOrderType,
} from 'state';
import { formatters } from 'services';
import type { TableColumnGroupType as ColumnGroupType, TableColumnType as ColumnType } from 'antd';
import { dateWithTimeSeconds } from 'services/formatters';
import {
  pendingMoosSelector,
  pendingSLTPsSelector,
  triedAndFailedOrdersSelector,
} from '../../../state/app/selectors';

const { Title } = Typography;

const PendingSLsTPs: React.FC = () => {
  const dispatch = useDispatch();
  const pendingSLTPs = useSelector(selectors.pendingSLTPsSelector);
  const pendingSLTPsList = Object.values(pendingSLTPs.items);

  useEffect(() => {
    if (!pendingSLTPs.fetched) {
      dispatch(retrievePendingSlTps({}));
    }
  }, []);

  const columns: ((
    | ColumnGroupType<PartialOrderType>
    | ColumnType<PartialOrderType>
  ) & {
    dataIndex: string;
  })[] = [
    {
      title: 'id',
      dataIndex: 'id',
    },
    {
      title: 'Player',
      dataIndex: 'player',
    },
    {
      title: 'Asset',
      dataIndex: 'asset_name',
    },
    {
      title: 'Type',
      dataIndex: 'order_type',
    },
    {
      title: 'Txn.',
      dataIndex: 'transaction',
      render: (val: keyof typeof TRANSACTION_TYPES) => {
        return TRANSACTION_TYPES[val];
      },
    },
    {
      title: 'Limit Price',
      dataIndex: 'limit_price',
    },
    {
      title: 'Qty.',
      dataIndex: 'quantity',
      render: (val, record) => {
        if (record.transaction === BUY) {
          return formatters.commas1Digit(val);
        } else {
          return formatters.commas1Digit(-val);
        }
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (status: keyof typeof ORDER_STATUSES) => {
        return ORDER_STATUSES[status];
      },
    },
    {
      title: 'timestamp',
      dataIndex: 'timestamp',
      // width: 250,
      defaultSortOrder: 'descend',
      sorter: (a: PartialOrderType, b: PartialOrderType) => {
        const dateA = formatters.dateWithTime(a.timestamp || '');
        const dateB = formatters.dateWithTime(b.timestamp || '');
        return dateA.localeCompare(dateB);
      },
      render: val => formatters.dateWithTime(val),
      // fixed: 'right',
    },
  ];

  return (
    <div>
      <Typography.Title level={4}>Pending SL/TPs</Typography.Title>
      <Table
        // style={{ width: '1000px' }}
        columns={columns}
        dataSource={pendingSLTPsList}
        pagination={{ pageSize: 10 }}
        bordered
      />
    </div>
  );
};
// deploy
export default PendingSLsTPs;
